import { useRef, useState } from "react";
// import { useTranslation } from "react-i18next";

import "./SuccessfullMessage.css";
import { Form } from "reactstrap";
import { getSignupPublicPath, getSignupSiteOrigin } from "../../config/signupSite";

const SuccessfullMessage = ({ loading, setLoading, submittedData }) => {
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(Array(6).fill(""));
  // const { t, i18n } = useTranslation();

  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Allow only one digit

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").slice(0, 6).split("");
    if (pasted.every((ch) => /^\d$/.test(ch))) {
      const newOtp = [...otp];
      pasted.forEach((char, idx) => {
        if (idx < 6) newOtp[idx] = char;
      });
      setOtp(newOtp);
      if (inputRefs.current[pasted.length - 1]) {
        inputRefs.current[pasted.length - 1].focus();
      }
    }
  };

  const onSubmitHandler = () => {
    
    const otpValue = otp.join("").trim();

    if (otpValue.length !== 6 || !/^\d{6}$/.test(otpValue)) {
      console.error("Please enter a valid 6-digit OTP.");
      return;
    }

    console.log("OTP Submitted:", otpValue);

    if (otpValue === submittedData?.otp) {
      console.log("OTP is valid");
      const signupOrigin = getSignupSiteOrigin();
      const publicPath = getSignupPublicPath();
      window.location.href = `${signupOrigin}${publicPath}/emailVerified/?token=${submittedData?.link}`;
    } else {
      console.error("Invalid OTP entered.");
    }
  };

  return (
    <div className={`d-flex align-items-center justify-content-center`} style={{ height: "100vh" }}>
      <div className="container otp-container text-center py-3">
        <img src="/optIcon.png" alt="OTP Icon" />
        <h2>Enter OTP</h2>
        <p>Please enter the 6-digit code sent to your email.</p>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmitHandler(otp.join(""));
          }}
        >
          <div className="otp-inputs" onPaste={handlePaste}>
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={(el) => (inputRefs.current[index] = el)}
              />
            ))}
          </div>

          <button type="submit" className="btn">
            Verify and Proceed
          </button>
        </Form>

        <div class="or">OR</div>

        <p class="alt-link">
            Please use the verification link sent to your email
        </p>
      </div>
    </div>
  );
};

export default SuccessfullMessage;
